export default "__VITE_ASSET__CFKPmBv2__"